module.exports = "<div class=\"wrapperPanel\" >\r\n  <div class=\"blueHeader\" ><h1>{{Title}}</h1></div>\r\n    <ng-content></ng-content>\r\n</div>\r\n\r\n\r\n\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/StartApp/welcome/start/simulator/panel-wrapper/panel-wrapper.component.html
// module id = ./src/app/StartApp/welcome/start/simulator/panel-wrapper/panel-wrapper.component.html
// module chunks = main